"use client";

import { Typography } from "antd";
import React, { useRef, useState } from "react";

import AppModal from "../../appModal";
import VideoPlayer from "../../VideoPlayerWithModal";

const VIDEO_MODAL_SYNC_DELAY_MS = 100;

const VideoAbout = () => {
  const { Title } = Typography;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const cardVideoRef = useRef<HTMLVideoElement>(null);
  const modalVideoRef = useRef<HTMLVideoElement>(null);

  const showModal = () => {
    if (cardVideoRef.current) {
      const currentTime = cardVideoRef.current.currentTime;
      setIsModalOpen(true);
      setTimeout(() => {
        if (modalVideoRef.current) {
          modalVideoRef.current.currentTime = currentTime;
          modalVideoRef.current.play();
        }
      }, VIDEO_MODAL_SYNC_DELAY_MS);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    if (modalVideoRef.current) {
      modalVideoRef.current.pause();
    }
  };

  return (
    <div>
      <div className="flex flex-col gap-6">
        <div className="flex flex-col items-center w-full">
          <Title level={1} className="H1 text-center">
            درباره ما
          </Title>
          <p className="text-regal-black-lighter text-center w-full sm:w-2/3">
            داستان ما، داستان یک تغییر بزرگ است. از همان ابتدا تصمیم گرفتیم تمام
            واسطه‌ها را کنار بگذاریم تا بتوانید باکیفیت‌ترین پنل‌های خورشیدی را
            مستقیم و به‌راحتی از ما تهیه کنید. این فقط یک رویکرد تجاری نیست،
            بلکه یک فلسفه روشن است: کیفیت برتر برای همه، با قیمت واقعی و
            منصفانه. تابرق به‌عنوان یکی از مجموعه‌های هلدینگ فراناب انرژی، با
            تکیه بر دانش بومی و رویکردی ملی، در مسیر توسعه انرژی‌های پاک و
            آینده‌ای پایدار برای ایران گام برمی‌دارد.
          </p>
        </div>
        <VideoPlayer
          videoSrc="/video/movie.mp4"
          onFullscreenClick={showModal}
          videoRef={(el) => (cardVideoRef.current = el)}
          className="w-full h-[70vw] mx-auto sm:w-2/3 sm:h-80 lg:h-96 xl:h-[28rem] 2xl:h-[30rem] max-h-[31.5rem]"
          type="singleVideo"
          videoIconSize="xs:w-38 xs:h-38 xl:w-40 xl:h-40"
          fullScreenSize="xs:w-10 xs:h-10 xl:w-12 xl:h-12"
          fullScreenIconSize="sm:w-8 sm:h-8 xl:w-10 xl:h-10"
        />
      </div>
      <AppModal
        isModalOpen={isModalOpen}
        modalTitle="درباره ما"
        closeModal={closeModal}
      >
        <video
          ref={modalVideoRef}
          controls
          className="w-full h-[70vh] object-contain rounded-md bg-black"
        >
          <source src="/video/movie.mp4" type="video/mp4" />
        </video>
      </AppModal>
    </div>
  );
};

export default VideoAbout;
